module.exports = __webpack_public_path__ + "./fonts/e8ec793b32174809ae19ba3e176f290b.woff2";